import { render, staticRenderFns } from "./HomeAbout.vue?vue&type=template&id=5630feee"
import script from "./HomeAbout.vue?vue&type=script&lang=js"
export * from "./HomeAbout.vue?vue&type=script&lang=js"
import style0 from "./HomeAbout.vue?vue&type=style&index=0&id=5630feee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports